import * as Html from "../util/Html.ts";
import {ContactCache} from "../contact/ContactCache.ts";
import { SearchController, easyScorer } from "./searchController.ts";
import CONTACTS_LIST_TEMPLATE from "../contact/contacts_list_item.mustache";
import CONTACTS_LIST_NOMATCH from "../contact/contacts_list_nomatch.mustache";


export {initDom,destroyDom}

Html.registerWidget('widget/SearchContact',{initDom,destroyDom})

var controller;

function initDom(element: HTMLElement){
    const input = element.parentElement?.querySelector('input') as HTMLInputElement;
    controller = new SearchController(element, input, CONTACTS_LIST_TEMPLATE, CONTACTS_LIST_NOMATCH, ContactCache, easyScorer({firstName:4,lastName:5,devices:{value:3}}))
}
function destroyDom(element: HTMLElement){
    controller.destroy();
    controller = undefined;
}